/**
 * Russian for the 09 home pages (§3, §4). Complete for the keys the homes own, so the type
 * makes a missing translation a compile error rather than a silent fallback.
 */
import type { TranslationKey } from "./uz";

export type Home09Key = Extract<TranslationKey, `home09.${string}`>;

export const ru09Home: Record<Home09Key, string> = {
  "home09.error": "Не удалось загрузить главную страницу",
  "home09.retry": "Повторить",
  "home09.unknownClient": "Неизвестный клиент",
  "home09.duration.minutes": "{minutes} мин",
  "home09.duration.hours": "{hours} ч",
  "home09.duration.hoursMinutes": "{hours} ч {minutes} мин",
  "home09.summary.operator": "Сегодня дел: {total}. Главное: {priority}.",
  "home09.summary.operator.empty": "Сегодня в очереди нет дел.",
  "home09.summary.priority.new_lead": "позвонить по новым обращениям ({count})",
  "home09.summary.priority.awaiting_reply": "ответить клиентам ({count})",
  "home09.summary.priority.ai_draft": "проверить черновики AI ({count})",
  "home09.summary.priority.task": "выполнить задачи ({count})",
  "home09.summary.priority.payment_due": "напомнить об оплате ({count})",
  "home09.summary.priority.next_step": "сделать следующий шаг по сделкам ({count})",
  "home09.summary.priority.follow_up": "связаться с клиентами повторно ({count})",
  "home09.summary.manager.both": "Вас ждут решения ({count}), и в филиалах {branches} есть обращения без ответа.",
  "home09.summary.manager.decisions": "Вас ждут решения ({count}).",
  "home09.summary.manager.unanswered": "В филиалах {branches} есть обращения без ответа.",
  "home09.summary.manager.calm": "Нет ожидающих решений и обращений без ответа.",
  "home09.cards.label": "Работа на сегодня",
  "home09.cards.start": "Начните отсюда",
  "home09.cards.newLeads": "Новое обращение",
  "home09.cards.newLeadsHint": "дольше всех ждёт {duration}",
  "home09.cards.newLeadsNone": "очередь пуста",
  "home09.cards.awaiting": "Ждут ответа",
  "home09.cards.awaitingHint": "первый: {name}",
  "home09.cards.awaitingNone": "всем ответили",
  "home09.cards.tasks": "Задачи на сегодня",
  "home09.cards.tasksOverdue": "просрочено: {count}",
  "home09.cards.tasksNone": "просроченных нет",
  "home09.cards.payments": "Платежи на сегодня",
  "home09.cards.paymentsTotal": "Всего собрать {amount}",
  "home09.cards.paymentsNone": "сегодня платежей нет",
  "home09.banner.overdue": "Просрочено задач: {count}",
  "home09.banner.review": "Посмотреть →",
  "home09.queue.title": "Очередь дел",
  "home09.queue.chips": "Тип дела",
  "home09.queue.chip.all": "Все",
  "home09.queue.chip.call": "Звонок",
  "home09.queue.chip.reply": "Ответ",
  "home09.queue.chip.pay": "Оплата",
  "home09.queue.empty": "Дел такого типа нет",
  "home09.queue.showAll": "Показать все дела ({count})",
  "home09.queue.showLess": "Показать меньше",
  "home09.queue.also": "Ещё: {reasons}",
  "home09.queue.waiting": "ждёт {duration}",
  "home09.queue.overdue": "Просрочено",
  "home09.queue.today": "Сегодня",
  "home09.queue.tomorrow": "Завтра",
  "home09.queue.todayUntil": "Сегодня до {time}",
  "home09.queue.tomorrowAt": "Завтра {time}",
  "home09.reason.new_lead": "Новое обращение",
  "home09.reason.awaiting_reply": "Ждёт ответа",
  "home09.reason.ai_draft": "Черновик AI готов",
  "home09.reason.task": "Задача",
  "home09.reason.payment_due": "Срок оплаты",
  "home09.reason.next_step": "Следующий шаг",
  "home09.reason.follow_up": "День повторного контакта",
  "home09.action.take": "Взять",
  "home09.action.reply": "Ответить",
  "home09.action.remind": "Напомнить",
  "home09.action.open": "Открыть",
  "home09.results.title": "Мой результат",
  "home09.results.sales": "Продажи",
  "home09.results.conversion": "Конверсия",
  "home09.results.previousConversion": "было {value}",
  "home09.results.same": "как в прошлом месяце",
  "home09.results.change": "{change} к прошлому месяцу",
  "home09.tip.title": "Совет AI",
  "home09.tip.prepare": "Подготовить текст предложения",
  "home09.tip.later": "Позже",
  "home09.tip.year_ago_trip": "{name} год назад в это время путешествовал(а) ({destination}). Время предложить новый сезон.",
  "home09.tip.returned_from_trip": "{name} вернулся(ась) из поездки ({destination}). Спросите впечатления и предложите следующую поездку.",
  "home09.tip.generic": "Пора сделать новое предложение: {name} ({destination}).",
  "home09.tip.noDestination": "направление не указано",
  "home09.near.title": "Близко к продаже",
  "home09.near.empty": "Нет сделок, близких к продаже",
  "home09.filters.branch": "Филиал",
  "home09.filters.allBranches": "Все филиалы",
  "home09.filters.period": "Период",
  "home09.filters.week": "Эта неделя",
  "home09.filters.month": "Месяц",
  "home09.alert.title": "{branch}: обращений без ответа {count}, уже {minutes} мин",
  "home09.alert.consequence": "Клиент без ответа может написать в другое агентство.",
  "home09.alert.assign": "Назначить оператора",
  "home09.delta.lastWeek": "к прошлой неделе",
  "home09.delta.lastMonth": "к прошлому месяцу",
  "home09.delta.points": "п.п.",
  "home09.kpi.label": "Основные показатели",
  "home09.kpi.revenue": "Выручка (брутто)",
  "home09.kpi.margin": "Чистая прибыль (маржа)",
  "home09.kpi.conversion": "Конверсия",
  "home09.kpi.average": "Средний чек",
  "home09.branches.title": "Сравнение филиалов",
  "home09.col.branch": "Филиал",
  "home09.col.leads": "Обращения",
  "home09.col.firstResponse": "Первый ответ",
  "home09.col.sales": "Продажи",
  "home09.col.conversion": "Конверсия",
  "home09.col.revenue": "Выручка",
  "home09.col.margin": "Маржа",
  "home09.col.operator": "Оператор",
  "home09.col.overdue": "Просрочено",
  "home09.branches.minutes": "{minutes} мин",
  "home09.operators.title": "Операторы",
  "home09.operators.report": "Подробный отчёт →",
  "home09.operators.empty": "Операторов нет",
  "home09.funnel.title": "Воронка продаж",
  "home09.funnel.empty": "За период обращений нет",
  "home09.funnel.insufficient": "Для вывода нужно не меньше {minimum} обращений на этапе.",
  "home09.funnel.weakest": "{from} → {to}: переход {rate}%, из {base} остановились {lost}.",
  "home09.directions.title": "Выручка по направлениям",
  "home09.directions.other": "Другие",
  "home09.directions.empty": "За период выручки нет",
};
